import { render, staticRenderFns } from "./CommunicationChannel.vue?vue&type=template&id=a08a49b2"
import script from "./CommunicationChannel.vue?vue&type=script&lang=js"
export * from "./CommunicationChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports